var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { property, listing_index, map } = options; 
__p+='\n\n<div class="listing-'+
((__t=( listing_index ))==null?'':__t)+
' listing-card-compact browse-module-card js-tracking" data-url="'+
((__t=( property.ldp_url ))==null?'':__t)+
'" data-propertyid="'+
((__t=( property.property_id ))==null?'':__t)+
'" data-status="'+
((__t=( property.prop_status ))==null?'':__t)+
'" data-listingid="'+
((__t=( property.listing_id ))==null?'':__t)+
'">\n  <div class="highlight-card-label">\n    <div class="text-capitalize">\n      '+
((__t=( property.neighborhood_highlight.replace(/_/g, ' ') ))==null?'':__t)+
'\n    </div>\n  </div>\n  <a href="'+
((__t=( property.ldp_url ))==null?'':__t)+
'" aria-label="'+
((__t=( property.address_display ))==null?'':__t)+
'" class="bm-link-overlay" data-omtag="'+
((__t=( map[property.neighborhood_highlight] ))==null?'':__t)+
'" itemprop="url" target="_blank"></a>\n  ';

    let photo_class = '';
    if (!property.photo_url) { photo_class = "photo-not-available-480w"};
  
__p+='\n  <div class="aspect-content compact-card-image-wrapper '+
((__t=( photo_class ))==null?'':__t)+
'">\n    ';
 if (property.photo_url){ 
__p+='\n      ';
 if (listing_index <= 5){
__p+='\n        <img data-src="'+
((__t=( property.photo_url ))==null?'':__t)+
'" class="compact-card-image" alt="'+
((__t=( property.full_address_display ))==null?'':__t)+
'">\n      ';
 } else { 
__p+='\n        <img data-src="'+
((__t=( property.photo_url ))==null?'':__t)+
'" class="owl-lazy compact-card-image" alt="'+
((__t=( property.full_address_display ))==null?'':__t)+
'">\n      ';
 } 
__p+='\n    ';
 } else { 
__p+='\n      <div class="image-placeholder"></div>\n    ';
 } 
__p+='\n    <div class="compact-card-price">\n      '+
((__t=( property.price_display ))==null?'':__t)+
'\n    </div>\n  </div>\n  <div class="compact-card-content">\n    <div class="compact-card-address ellipsis">\n      <span itemprop="address" itemscope itemtype="http://schema.org/PostalAddress">\n        ';
 if (property.address_display){ 
__p+='\n          <span itemprop="streetAddress">'+
((__t=( property.address_display ))==null?'':__t)+
'</span>\n\n        ';
 } else { 
__p+='\n          <span itemprop="streetAddress">Address Not Available</span>\n        ';
 } 
__p+='\n      </span>\n      <span itemprop="geo" itemscope itemtype="http://schema.org/GeoCoordinates">\n        <meta itemprop="latitude" content="'+
((__t=( property.lat ))==null?'':__t)+
'">\n        <meta itemprop="longitude" content="'+
((__t=( property.lon ))==null?'':__t)+
'">\n      </span>\n    </div>\n    <div class="compact-card-meta">\n      ';
 if (((property.beds) || (property.baths)) || (property.sqft_display)){ 
__p+='\n        <ul class="list-horizontal list-style-disc">\n          ';
 if (property.beds){ 
__p+='\n            <li data-label="compact-meta-beds">'+
((__t=( property.beds ))==null?'':__t)+
' bd</li>\n          ';
 } 
__p+='\n          ';
 if (property.baths){ 
__p+='\n            <li data-label="compact-meta-baths">'+
((__t=( property.baths ))==null?'':__t)+
' ba</li>\n          ';
 } 
__p+='\n          ';
 if (property.sqft_display){ 
__p+='\n            <li class="compact-meta-sqft " data-label="property-meta-sqft">'+
((__t=( property.sqft_display ))==null?'':__t)+
' sqft</li>\n          ';
 } 
__p+='\n        </ul>\n      ';
 } else {
__p+='\n        Nearby Property\n      ';
 } 
__p+='\n    </div>\n  </div>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/home-around/browse-module-card.jst.ejs